import React, { useState, useEffect, createContext } from 'react';

import axios from 'axios';
import toast from 'react-hot-toast';
import CartData from './cartData';
import Loader from './loader';

import { link } from '../dynamic/api';

export const DataContext = createContext();
export const CartContext = createContext();

function GetData(props) {

  const { setAccess, userName, token, expireyDate, localApi, serverApi, devSetting } = props;


  let api;
  if (!devSetting?.isServer && userName !== 'dev') {
    api = serverApi;
  } else {
    api = localApi;
  }

  const [loaderEffect, setLoaderEffect] = useState(true);

  const [refProduct, setRefProduct] = useState([]);

  const [accountData, setAccountData] = useState([]);


  const [settingData, setSettingData] = useState(0);
  const [refSetting, setRefSetting] = useState(0);

  const [roleData, setRoleData] = useState([]);
  const [refRoleData, setRefRoleData] = useState([]);

  const [userData, setUserData] = useState('');

  const [allUserData, setAllUserData] = useState([]);

  const [devData, setDevData] = useState([]);
  const [trainerData, setTrainerData] = useState([]);
  const [accountTrainerData, setTrainerAccountData] = useState([]);
  const [accountMemberData, setMemberAccountData] = useState([]);
  const [classData, setClassData] = useState([]);
  const [memberData, setMemberData] = useState([]);

  const [membershipData, setMembershipData] = useState([]);



  // Data to get
  useEffect(() => {
    refDevData();
  }, []);


  const refreshProduct = () => {
    setRefProduct(!refProduct)
  }

  const refreshSetting = () => {
    setRefSetting(!refSetting)
  }


  const refreshRole = () => {
    setRefRoleData(!refRoleData)
  }


  // Tempor run
  useEffect(() => {
    
  }, []);


  // Get All User Data
  const refAllUserData = async () => {
    try {
      let data = { isActive: true };
      const response = await api.get(`/user/getAll`, { params: data });
      if (response) {
        setAllUserData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };



  
    // Get Role
    const refRole = async () => {
      try {
        let data = { filter: { isActive: 'true' } };
        const response = await api.get(`/role/getAll`, { params: data });
        if (response) {
          setRoleData(response.data.data);
          console.log("roles",roleData);
        }
      } catch (error) {
        toast.error('' + error);
      }
    };
  



   
  const refAccountTrainer = async () => {
    try {
      let data = { filter: { isActive: 'true', type: "trainer" } };
      const response = await api.get(`/account/getAll`, { params: data });
      if (response) {
        setTrainerAccountData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };

  const refAccountMember = async () => {
    try {
      let data = { filter: { isActive: 'true', type: "member" } };
      const response = await api.get(`/account/getAll`, { params: data });
      if (response) {
        setMemberAccountData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };
    // Get Class
    const refClass = async () => {
      try {
        let data = { filter: { isActive: 'true' } };
        const response = await api.get(`/class/getAll`, { params: data });
        if (response) {
          setClassData(response.data.data);
        }
      } catch (error) {
        toast.error('' + error);
      }
    };

    // Get Members
    const refMember = async () => {
      try {
        let data = { filter: { isActive: 'true' } };
        const response = await api.get(`/member/getAll`, { params: data });
        if (response) {
          setMemberData(response.data.data);
        }
      } catch (error) {
        toast.error('' + error);
      }
    };

    const refTrainer = async () => {
      try {
        let data = { filter: { isActive: 'true', type: 'trainer' } }; // Added type filter
        const response = await api.get(`/account/getAll`, { params: data });
        if (response) {
          setTrainerData(response.data.data);
        }
      } catch (error) {
        toast.error('' + error);
      }
    };
    

   



  // Get User Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        let data = { userName: userName };
        const response = await api.get(`/user/getUser`, { params: data });
        if (response) {
          setUserData(response.data.data);
        }
      } catch (error) {
        toast.error('' + error);
      }
    };
    fetchData();
  }, []);



  //Ref Account data
  const refAccountData = async () => {
    try {
      let data = { filter: { isActive: 'true' } };
      const response = await api.get(`/account/getAll`, { params: data });
      if (response) {
        setAccountData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };

 
  // Get Settings
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(`/Setting/getAll`);
        if (response) {
          setSettingData(response.data.data[0]);
        }
      } catch (error) {
        toast.error('' + error);
      }
    };
    fetchData();
  }, [refSetting]);





  // Get DevData using localApi
  const refDevData = async () => {
    try {
      let data = { isActive: true };
      const response = await localApi.get(`/dev/getAll`, { params: data });
      if (response) {
        setDevData(response.data.data[0]);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };

  const fetchLatestMembershipsForClass = async (classId) => {
    try {
      const response = await api.get(`/newTransaction/getLatestMembershipForEachClass`, { params: { classId } });
      return response.data.data;
    } catch (error) {
      toast.error('Failed to fetch latest memberships for the selected class.');
      throw error;
    }
  };




  return (
    <div>

      <DataContext.Provider
        value={{
          setLoaderEffect,
          expireyDate,
          api,
          userData,
          refreshProduct,

          settingData,
          refreshSetting,

          roleData,
          refRole,
          setAccess,

          devData,
          refDevData,

          serverApi,
          localApi,

          trainerData,
          refTrainer,

          accountTrainerData,
          refAccountTrainer,

          accountMemberData,
          refAccountMember,

          classData,
          refClass,

          memberData,
          refMember,

          accountData,
          refAccountData,

          refAllUserData,
          allUserData,

          devSetting,

          fetchLatestMembershipsForClass

         

        }}>


        {loaderEffect &&
          <Loader />
        }


        {userData && settingData &&
          <CartData setAccess={setAccess} settingData={settingData} userData={userData} />
        }



      </DataContext.Provider>




    </div>

  );
}


export default GetData;